import { all, takeLatest } from 'redux-saga/effects';

import { handleRequest } from '@sagas/request';
import { sendHelpEmailRequest } from '@store/help';

/* @ts-expect-error This will error until handleRequest has been converted to TS */
export default all([takeLatest(sendHelpEmailRequest.type, handleRequest)]);
